exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2953cf5d]::-webkit-scrollbar {\n  width: 10px;\n}\n[data-v-2953cf5d]::-webkit-scrollbar-thumb {\n  background: #c7c5c5;\n  border-radius: 5px;\n}\n[data-v-2953cf5d]::-webkit-scrollbar-thumb:hover {\n  background: grey;\n}\n\n", ""]);

// exports
